import { defineMessages } from 'react-intl';

import { SportTermLookup, SportTerminology } from '../../../lib/types';

export const scope = 'app.components.Communication.VariablePanel';

export const getMessages = (termLookup: SportTermLookup) =>
  defineMessages({
    toggle: { id: `${scope}.toggle`, defaultMessage: 'Variables' },
    intro: {
      id: `${scope}.intro`,
      defaultMessage: 'Click a variable to insert it — it fills in per recipient when the message sends.'
    },
    loading: { id: `${scope}.loading`, defaultMessage: 'Loading variables…' },
    groupPlayer: {
      id: `${scope}.groupPlayer`,
      defaultMessage: termLookup[SportTerminology.ATHLETE]
    },
    groupAssessment: { id: `${scope}.groupAssessment`, defaultMessage: 'Assessment' },
    groupAgeGroup: { id: `${scope}.groupAgeGroup`, defaultMessage: 'Age group' },
    groupSession: {
      id: `${scope}.groupSession`,
      defaultMessage: termLookup[SportTerminology.SESSION]
    },
    exampleTooltip: { id: `${scope}.exampleTooltip`, defaultMessage: 'e.g. {example}' },
    requiresFallbackTooltip: {
      id: `${scope}.requiresFallbackTooltip`,
      defaultMessage: 'Can be blank for some recipients — inserting asks for a default.'
    },
    fallbackLabel: { id: `${scope}.fallbackLabel`, defaultMessage: 'Default if blank' },
    fallbackHint: {
      id: `${scope}.fallbackHint`,
      defaultMessage: 'Used for recipients missing this value. Leave empty to insert a blank.'
    },
    fallbackInsert: { id: `${scope}.fallbackInsert`, defaultMessage: 'Insert' },
    copied: { id: `${scope}.copied`, defaultMessage: 'Copied' },
    copyFailed: { id: `${scope}.copyFailed`, defaultMessage: "Couldn't copy" }
  });
